// extracted by mini-css-extract-plugin
module.exports = {"passion":"Passion-module--passion--2UmqP"};